import { Icon, IconProps } from './Icon';

export const ClockIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 20 20"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.1942 2.55664C14.74 3.15247 17.4442 6.22914 17.4442 9.94414C17.4442 14.0866 14.0867 17.4441 9.94417 17.4441C6.22917 17.4441 3.1525 14.74 2.55667 11.1941"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.55584 8.6937C2.63501 8.22286 2.75751 7.7687 2.92001 7.33203"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.16418 4.16406C4.80001 4.4649 4.46584 4.79906 4.16501 5.16323"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.69416 2.55643C8.22332 2.6356 7.76832 2.75893 7.33249 2.92143"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3258 5.83398V10.3265H6.66666"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);
